import { CFTokens } from '../../../tokens';
export const ANIMATION_DURATION = CFTokens.ANIMATED_HEIGHT_DEFAULT_OPTIONS.duration;
export const BACKGROUND_COLOR = {
    ACTIVE: CFTokens.COLOR.BACKGROUND_WARM_2,
    DEFAULT: CFTokens.COLOR.SALT_8,
};
export const BORDER = CFTokens.BORDER.SUBTLE;
export const BORDER_RADIUS = {
    ROOT: CFTokens.BORDER_RADIUS.B,
    TRIGGER_ICON: CFTokens.BORDER_RADIUS.A,
};
export const PADDING = {
    BLOCK_PANEL_BOTTOM: CFTokens.SPACER.E,
    BLOCK_PANEL_TOP: CFTokens.SPACER.B,
    BLOCK_TRIGGER: CFTokens.SPACER.C,
    INLINE: CFTokens.SPACER.D,
};
